import { render, staticRenderFns } from "./WizardContentHeadingIndicator.vue?vue&type=template&id=32eb291c&scoped=true&"
import script from "./WizardContentHeadingIndicator.vue?vue&type=script&lang=ts&"
export * from "./WizardContentHeadingIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentHeadingIndicator.vue?vue&type=style&index=0&id=32eb291c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb291c",
  null
  
)

export default component.exports